import { Injectable } from '@angular/core';
import { TimezoneLabels } from '@shared/constants/constants';
import * as moment from 'moment';

@Injectable()
export class TimezoneService {

  // Get timezone label
  public getTimezoneLabel(time: Date, timezoneId: string): string {
    let timezoneLabel = '';
    let isDST = false;

    isDST = moment(time).isDST();

    if (TimezoneLabels?.find(x => x.id === timezoneId)) {
      timezoneLabel = TimezoneLabels?.find(x => x.id === timezoneId)?.labels?.find(y => y.isDST === isDST)?.text;
    }

    return timezoneLabel;
  }

  // Convert Zoom timezones to Microsoft timezones
  // https://developers.zoom.us/docs/api/rest/other-references/abbreviation-lists/#timezones
  public convertZoomTimezone(zoomTimezone: string): string {
    let timezone = null;

    switch (zoomTimezone) {
      case 'UTC':
      case 'Etc/Greenwich':
      case 'Europe/Dublin':
      case 'Europe/London':
        timezone = 'GMT Standard Time';
        break;
      case 'Europe/Belgrade':
      case 'CET':
      case 'Atlantic/Reykjavik':
      case 'Europe/Oslo':
      case 'Europe/Copenhagen':
      case 'Europe/Brussels':
      case 'Europe/Berlin':
      case 'Europe/Amsterdam':
      case 'Europe/Rome':
      case 'Europe/Stockholm':
      case 'Europe/Vienna':
      case 'Europe/Luxembourg':
      case 'Europe/Paris':
      case 'Europe/Zurich':
      case 'Europe/Madrid':
        timezone = 'W. Europe Standard Time';
        break;
      case 'Europe/Lisbon':
      case 'Europe/Helsinki':
        timezone = 'FLE Standard Time';
        break;
      case 'America/Los_Angeles':
        timezone = 'Pacific Standard Time';
        break;
      case 'America/Denver':
        timezone = 'Mountain Standard Time';
        break;
      case 'America/Chicago':
        timezone = 'Central Standard Time';
        break;
      case 'America/New_York':
        timezone = 'Eastern Standard Time';
        break;
      case 'America/Araguaina':
      case 'America/Argentina/Buenos_Aires':
        timezone = 'E. South America Standard Time';
        break;
      case 'Asia/Bangkok':
      case 'Asia/Saigon':
      case 'Asia/Jakarta':
        timezone = 'SE Asia Standard Time';
        break;
      case 'Asia/Shanghai':
      case 'Asia/Hong_Kong':
      case 'Asia/Taipei':
      case 'Asia/Irkutsk':
      case 'Asia/Singapore':
        timezone = 'China Standard Time';
        break;
    }

    return timezone;
  }

}
